(() => {
  if (window.__gfAdvInit) return;
  window.__gfAdvInit = true;
  const ALIAS = {
    azyl: 'azyl', vrachioli: 'azyl', vrachiolia: 'azyl', bransoletka: 'azyl', katafygio: 'azyl',
    miyuki: 'miyuki',
    neck: 'neck', kolie: 'neck', naszyjnik: 'neck', agkalia: 'neck', gata: 'neck',
  };
  function wanted() {
    let p = '';
    try {
      p = new URLSearchParams(location.search).get('p') || '';
      if (!p && location.hash) p = decodeURIComponent(location.hash.slice(1));
    } catch {}
    p = (p || '').toLowerCase().trim();
    return ALIAS[p] || '';
  }
  const pickerEl = () => document.querySelector('[data-nl-adv-picker]');
  const barEl = () => document.querySelector('[data-nl-adv-bar]');
  const panelsOf = (picker) => (picker ? [...picker.querySelectorAll('[data-nl-adv-panel]')] : []);
  const activePanel = (picker) => panelsOf(picker).find((p) => !p.hidden) || null;
  const money = (cents) => `${(Math.round(Number(cents)) / 100).toFixed(2).replace('.', ',')} €`;

  async function addItems(items, source = 'nl-bundle') {
    const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    const body = { items };
    if (ids.length) { body.sections = [...new Set(ids)].join(','); body.sections_url = window.location.pathname; }
    const routes = (window.Theme && window.Theme.routes) || {};
    const res = await fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
    });
    let json = {};
    try { json = (await res.json()) || {}; } catch { json = {}; }
    if (!res.ok) throw new Error(json.description || json.message || 'Δεν ήταν δυνατή η προσθήκη στο καλάθι. Δοκίμασε ξανά σε λίγο.');
    const cart = (await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null)) || { item_count: null };
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'nl', data: { source, itemCount: cart.item_count, sections: json.sections } } }));
    return cart;
  }
  function flashError(host, message) {
    if (!host) return;
    let box = host.querySelector(':scope > .nl-form-err');
    if (!box) { box = document.createElement('div'); box.className = 'nl-form-err'; box.setAttribute('role', 'alert'); host.appendChild(box); }
    box.textContent = message;
    clearTimeout(box.__t);
    box.__t = setTimeout(() => box.remove(), 6000);
  }
  const drawerEl = () => document.querySelector('cart-drawer-component');
  function drawerOpen() { const d = drawerEl(); const dlg = d && d.querySelector('dialog'); return !!(dlg && dlg.open); }
  function openDrawer() { const d = drawerEl(); if (!d) return; if (typeof d.open === 'function') d.open(); else if (typeof d.showDialog === 'function') d.showDialog(); }
  function afterAdd() {
    let sawOffer = false; let done = false; let mo = null;
    const finish = () => { if (done) return; done = true; if (mo) mo.disconnect(); setTimeout(() => { if (!drawerOpen()) openDrawer(); }, 250); };
    mo = new MutationObserver(() => { if (document.querySelector('dialog.nl-offer')) sawOffer = true; else if (sawOffer) finish(); });
    mo.observe(document.body, { childList: true });
    setTimeout(() => { if (!sawOffer) finish(); }, 3500);
    setTimeout(() => { if (!done) { done = true; mo.disconnect(); } }, 120000);
  }
  function tierInfo(panel) {
    const bundle = panel && panel.querySelector('nl-bundle');
    if (!bundle) return null;
    const input = bundle.querySelector('.nl-tier__input:checked');
    const tier = input ? input.closest('.nl-tier') : bundle.querySelector('.nl-tier.is-on');
    return tier ? { qty: Number(tier.dataset.qty || 1), total: tier.dataset.total || '' } : null;
  }
  function unitCents(panel) { const on = panel.querySelector('.nl-adv-tile.is-on'); return on && on.dataset.price ? Number(on.dataset.price) : Number(panel.dataset.unit || 0); }
  function priceLabel(panel) { const t = tierInfo(panel); return t && t.qty > 1 && t.total ? t.total : money(unitCents(panel)); }
  function syncPrices(panel) {
    if (!panel) return;
    const btn = panel.querySelector('.nl-adv-add');
    if (!btn) return;
    const label = priceLabel(panel);
    const bp = btn.querySelector('[data-nl-adv-btnprice]');
    if (bp) bp.textContent = '· ' + label;
    else btn.innerHTML = (btn.dataset.label || 'Στο καλάθι') + ' <span class="nl-adv-add__p" data-nl-adv-btnprice>· ' + label + '</span>';
  }
  function panelItems(panel) {
    const btn = panel.querySelector('.nl-adv-add');
    const main = btn && btn.dataset.nlAdd;
    if (!main) return [];
    const bundle = panel.querySelector('nl-bundle');
    if (bundle && typeof bundle.items === 'function') return bundle.items(String(main));
    const t = tierInfo(panel);
    return [{ id: Number(main), quantity: t ? Math.max(1, t.qty) : 1 }];
  }
  function syncBar() {
    const bar = barEl(); const panel = activePanel(pickerEl());
    if (!bar || !panel) return;
    const btn = panel.querySelector('.nl-adv-add');
    const name = panel.querySelector('[data-nl-adv-name]');
    const img = panel.querySelector('.nl-adv-prod__media > img');
    const barName = bar.querySelector('[data-nl-adv-bar-name]');
    const barPrice = bar.querySelector('[data-nl-adv-bar-price]');
    const barImg = bar.querySelector('[data-nl-adv-bar-img]');
    const barBtn = bar.querySelector('[data-nl-adv-bar-add]');
    if (!btn || !btn.dataset.nlAdd || btn.disabled) { bar.hidden = true; return; }
    if (barBtn) barBtn.disabled = false;
    if (barName && name) barName.textContent = name.textContent.trim();
    if (barPrice) { const t = tierInfo(panel); barPrice.textContent = t && t.qty > 1 ? `${t.qty} τεμ. · ${priceLabel(panel)}` : priceLabel(panel); }
    if (barImg && img) barImg.src = img.currentSrc || img.src;
  }
  if (!window.__gfAdvAddBound) {
    window.__gfAdvAddBound = true;
    document.addEventListener('click', (e) => {
      const el = e.target instanceof Element ? e.target : null;
      if (!el) return;
      const btn = el.closest('.nl-adv-add, [data-nl-adv-bar-add]');
      if (!btn) return;
      const picker = pickerEl(); const bar = barEl();
      if (!picker || (!picker.contains(btn) && !(bar && bar.contains(btn)))) return;
      e.preventDefault(); e.stopPropagation();
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      const panel = activePanel(picker);
      if (!panel) return;
      const items = panelItems(panel);
      if (!items.length) return;
      const host = panel.querySelector('.nl-adv-prod__body') || panel;
      const label = btn.innerHTML;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      addItems(items, 'nl-bundle')
        .then(() => { btn.textContent = btn.dataset.added || 'Προστέθηκε ✓'; setTimeout(() => { if (btn.isConnected) btn.innerHTML = label; }, 2500); afterAdd(); })
        .catch((err) => flashError(host, err.message))
        .finally(() => { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
    }, true);
    document.addEventListener('cart:update', (e) => {
      const detail = (e.detail && e.detail.resource) || {};
      const cartBtn = document.querySelector('[data-nl-adv-cart]');
      const count = document.querySelector('[data-nl-adv-cart-count]');
      if (count && typeof detail.item_count === 'number') {
        count.textContent = detail.item_count;
        count.hidden = detail.item_count === 0;
        if (cartBtn) { cartBtn.classList.remove('is-bump'); void cartBtn.offsetWidth; cartBtn.classList.add('is-bump'); }
      }
      if ((e.detail && e.detail.data && e.detail.data.source) === 'gf-upsell' && document.body.classList.contains('nl-adv-layout')) {
        const d = drawerEl();
        if (d && typeof d.open === 'function' && !d.hasAttribute('auto-open')) setTimeout(() => d.open(), 120);
      }
    });
  }
  function init() {
    const picker = pickerEl(); const hero = document.querySelector('[data-nl-adv-hero]'); const bar = barEl(); const want = wanted();
    if (hero && want) {
      const sub = hero.querySelector('[data-nl-adv-sub]');
      const txt = hero.dataset['sub' + want.charAt(0).toUpperCase() + want.slice(1)];
      if (sub && txt) sub.textContent = txt;
    }
    if (!picker) return;
    const tabs = [...picker.querySelectorAll('[data-nl-adv-tab]')];
    const panels = panelsOf(picker);
    if (!panels.length) return;
    function select(name, focus) {
      const panel = panels.find((p) => p.dataset.nlAdvPanel === name) || panels[0];
      panels.forEach((p) => { p.hidden = p !== panel; });
      tabs.forEach((t) => {
        const on = t.dataset.nlAdvTab === panel.dataset.nlAdvPanel;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      syncPrices(panel); syncBar();
    }
    function pick(tile) {
      const panel = tile.closest('[data-nl-adv-panel]');
      if (!panel || tile.disabled) return;
      panel.querySelectorAll('.nl-adv-tile').forEach((t) => { const on = t === tile; t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on ? 'true' : 'false'); });
      const d = tile.dataset;
      const img = panel.querySelector('.nl-adv-prod__media > img');
      if (img && d.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = d.img; }
      const name = panel.querySelector('[data-nl-adv-name]');
      if (name && d.name) name.textContent = d.name;
      const price = panel.querySelector('[data-nl-adv-price]');
      const compare = panel.querySelector('[data-nl-adv-compare]');
      const cents = Number(d.price || 0); const cmp = Number(d.compare || 0);
      panel.dataset.unit = String(cents);
      if (price) price.textContent = money(cents);
      if (compare) { if (cmp > cents) { compare.textContent = money(cmp); compare.hidden = false; } else compare.hidden = true; }
      const save = panel.querySelector('[data-nl-adv-save]');
      if (save) { if (cmp > cents) { save.textContent = 'εξοικονομείς ' + money(cmp - cents); save.hidden = false; } else save.hidden = true; }
      const btn = panel.querySelector('.nl-adv-add');
      if (btn && d.variant) { btn.dataset.nlAdd = d.variant; btn.disabled = d.available === 'false'; }
      const bundle = panel.querySelector('nl-bundle');
      if (bundle && d.variant && typeof bundle.setMain === 'function') bundle.setMain(String(d.variant));
      const url = panel.querySelector('[data-nl-adv-url]');
      if (url && d.url) url.href = d.url;
      syncPrices(panel); syncBar();
    }
    picker.addEventListener('click', (e) => {
      const el = e.target instanceof Element ? e.target : null;
      if (!el) return;
      const tab = el.closest('[data-nl-adv-tab]');
      if (tab) { select(tab.dataset.nlAdvTab); return; }
      const tile = el.closest('.nl-adv-tile');
      if (tile) pick(tile);
    });
    picker.addEventListener('change', (e) => {
      const el = e.target instanceof Element ? e.target : null;
      if (!el || !el.classList.contains('nl-tier__input')) return;
      setTimeout(() => { syncPrices(el.closest('[data-nl-adv-panel]')); syncBar(); }, 0);
    });
    picker.addEventListener('keydown', (e) => {
      const el = e.target instanceof Element ? e.target : null;
      if (!el) return;
      if (el.matches('[data-nl-adv-tab]') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        const i = tabs.indexOf(el);
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        if (next) select(next.dataset.nlAdvTab, true);
      }
    });
    panels.forEach((p) => { if (!p.dataset.unit) p.dataset.unit = String(unitCents(p)); });
    const start = want || picker.dataset.defaultTab || panels[0].dataset.nlAdvPanel;
    select(panels.some((p) => p.dataset.nlAdvPanel === start) ? start : panels[0].dataset.nlAdvPanel);
    panels.forEach((p) => syncPrices(p));
    document.querySelectorAll('[data-nl-adv-go]').forEach((a) => {
      if (a.__gfAdvGo) return;
      a.__gfAdvGo = true;
      a.addEventListener('click', (e) => {
        const href = a.getAttribute('href') || '';
        if (!href.startsWith('#')) return;
        const target = document.querySelector(href);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
    if (bar && 'IntersectionObserver' in window) {
      let pickerVisible = false; let heroPassed = !hero;
      const update = () => { const show = heroPassed && !pickerVisible; bar.hidden = !show; document.body.classList.toggle('nl-adv-bar-on', show); };
      new IntersectionObserver((entries) => { entries.forEach((en) => { pickerVisible = en.isIntersecting; }); update(); }, { rootMargin: '-80px 0px -40% 0px' }).observe(picker);
      if (hero) new IntersectionObserver((entries) => { entries.forEach((en) => { heroPassed = !en.isIntersecting && en.boundingClientRect.top < 0; }); update(); }, { threshold: 0 }).observe(hero);
      bar.addEventListener('click', (e) => {
        const el = e.target instanceof Element ? e.target : null;
        if (el && el.closest('.nl-adv-bar__txt, .nl-adv-bar__img')) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    const cartBtn = document.querySelector('[data-nl-adv-cart]');
    if (cartBtn && !cartBtn.__gfAdv) {
      cartBtn.__gfAdv = true;
      cartBtn.addEventListener('click', () => { const d = drawerEl(); if (d && typeof d.open === 'function') d.open(); else window.location.href = '/cart'; });
    }
    document.addEventListener('shopify:section:load', () => { window.__gfAdvInit = false; init(); }, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
